import { definePreset } from '@primeng/themes';
import Aura from '@primeng/themes/aura';

const YtPreset = definePreset(Aura, {
  primitive: {
    green: {
      50: '#D2FFD6',
      100: '#97FFA2',
      200: '#00F24B',
      300: '#00D942',
      400: '#00C03A',
      500: '#00A731',
      600: '#008525',
      700: '#006319',
      800: '#00430E',
      900: '#002605',
      950: '#001802'
    },
    blue: {
      50: '#EDF0FF',
      100: '#D7DFFE',
      200: '#B2C2FD',
      300: '#85A2FC',
      400: '#4E83FB',
      500: '#1768E2',
      600: '#1052B6',
      700: '#0A3E8D',
      800: '#052B66',
      900: '#02183E',
      950: '#010F2E'
    },
    red: {
      50: '#FFE9E9',
      100: '#FFD6D6',
      200: '#FFABAC',
      300: '#FF7A7C',
      400: '#FF333B',
      500: '#D70015',
      600: '#AE000F',
      700: '#860009',
      800: '#600004',
      900: '#3D0002',
      950: '#270001'
    },
    black: {
      50: '#E7ECF0',
      100: '#D2DBE3',
      200: '#A4B9C8',
      300: '#82939F',
      400: '#64717B',
      500: '#475158',
      600: '#394147',
      700: '#2B3136',
      800: '#1F2428',
      900: '#121619',
      950: '#090B0D'
    }
  },
  semantic: {
    primary: {
      50: '{green.50}',
      100: '{green.100}',
      200: '{green.200}',
      300: '{green.300}',
      400: '{green.400}',
      500: '{green.500}',
      600: '{green.600}',
      700: '{green.700}',
      800: '{green.800}',
      900: '{green.900}',
      950: '{green.950}'
    },
    colorScheme: {
      light: {
        highlight: {
          color: '#FFFFFF',
          background: '{blue.500}',
          focusColor: '#FFFFFF',
          focusBackground: '{blue.500}'
        },
        formField: {
          color: '{black.700}',
          borderRadius: '4px',
          hoverBorderColor: '{blue.500}',
          focusBorderColor: '{blue.500}',
          placeholderColor: '{black.700}',
          invalidPlaceholderColor: '{red.500}'
        }
      },
      dark: {
        formField: {
          color: '{black.700}',
          borderRadius: '4px',
          focusBorderColor: '{blue.500}'
        }
      }
    }
  }
});

export default YtPreset;
